const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAesLogoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "21px",
    height: "33px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.909
    },
    fill: "#f48534",
    d: "M 3.5,-0.5 C 4.5,-0.5 5.5,-0.5 6.5,-0.5C 10.678,1.86714 11.5113,5.20048 9,9.5C 5.60278,10.9897 2.43612,10.6564 -0.5,8.5C -0.5,6.5 -0.5,4.5 -0.5,2.5C 0.871651,1.48837 2.20498,0.488369 3.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.927
    },
    fill: "#f48533",
    d: "M 20.5,13.5 C 20.5,15.5 20.5,17.5 20.5,19.5C 11.9927,23.922 8.82606,21.5886 11,12.5C 14.4172,9.90763 17.5839,10.241 20.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.925
    },
    fill: "#f58533",
    d: "M 8.5,32.5 C 6.16667,32.5 3.83333,32.5 1.5,32.5C 1.16667,31.5 0.5,30.8333 -0.5,30.5C -0.5,28.5 -0.5,26.5 -0.5,24.5C 4.42946,20.091 8.09613,20.9244 10.5,27C 10.2421,29.0093 9.57547,30.8427 8.5,32.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAesLogoIcon);
export default __webpack_public_path__ + "static/media/AES-logo-icon.c36576440f636b8dc5edf34f7209999b.svg";
export { ForwardRef as ReactComponent };